/* One native purchase form. This bar never submits or calls the cart API. */
(() => {
  if (customElements.get('sv-product')) return;
  customElements.define('sv-product', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-sv-bar]');
      if (!this.bar) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.proxy = this.bar.querySelector('[data-sv-buy]');
      this.price = this.bar.querySelector('[data-sv-price]');
      this.refresh = () => {
        const native = this.querySelector('.buy-button__add');
        const button = native?.querySelector('button');
        const action = native?.querySelector('xo-cart-add');
        const loading = action?.hasAttribute('xo-loading') && action.getAttribute('xo-loading') !== 'false';
        const form = button?.closest('form');
        const price = this.querySelector('.xo-product-info-content__price .xo-price__item:not(.xo-price__item--del)');
        const disabled = !button || loading || button.disabled || button.getAttribute('aria-disabled') === 'true' || !!native.closest('[xo-disabled]:not([xo-disabled="false"]), [disabled], [aria-busy="true"], [xo-loading]:not([xo-loading="false"])');
        const available = !!form && !!native && native.getBoundingClientRect().bottom < 0;
        const label = button?.textContent.trim() || 'Añadir al carrito';
        if (this.proxy.textContent !== label) this.proxy.textContent = label;
        this.proxy.disabled = disabled || !!this.lock;
        const value = price?.textContent.trim().replace(/\s+/g, ' ') || '';
        if (this.price.textContent !== value) this.price.textContent = value;
        this.bar.hidden = !available || !matchMedia('(max-width:767px)').matches;
        this.style.setProperty('--sv-bar-height', `${this.bar.getBoundingClientRect().height}px`);
      };
      this.proxy.addEventListener('click', () => {
        this.refresh();
        if (this.proxy.disabled) return;
        const button = this.querySelector('.buy-button__add button');
        if (!button) return;
        this.lock = true;
        this.proxy.disabled = true;
        button.click(); // Exactly one dispatch to the original theme handler.
        this.timer = setTimeout(() => { this.lock = false; this.refresh(); }, 1200);
      }, options);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
      };
      window.addEventListener('scroll', this.schedule, { ...options, passive:true });
      window.addEventListener('resize', this.schedule, options);
      this.observer = new MutationObserver(this.schedule);
      const nativeProduct = this.querySelector('xo-product');
      if (nativeProduct) this.observer.observe(nativeProduct, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','xo-disabled','xo-loading','aria-disabled','aria-busy'] });
      this.refresh();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect();
      cancelAnimationFrame(this.frame); clearTimeout(this.timer);
    }
  });
})();
